import React, { useContext, useEffect, useState } from 'react';
import { AccountDetailsValidationSchema } from '../../ValidationSchema/AccountDetailsValidationSchema';
import { ConfigContext } from '../../Context/ConfigContext';
import { useNavigate, useParams } from 'react-router-dom';
import FormUpdate from '../FormUpdate';
import { toast } from 'react-toastify';
import axios from 'axios';

const AddressDetails = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const navigate = useNavigate()
    const { customer_address_id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const [initialValues, setInitialValues] = useState({
        country: '',
        fullname: '',
        mobileNumber: '',
        address: '',
        area: '',
        pinCode: '',
        landmark: '',
        city: '',
        state: '',
        defaultAddress: false,
        rememberMe: false,
    })



    const handleCreate = async (values, { setSubmitting, resetForm, event }) => {
        event?.preventDefault();
        const transformedValues = {
            ...values,
            defaultAddress: values.defaultAddress ? 1 : 0,
        };

        try {
            const headers = apiHeaderJson;
            const body = {
                country_region: values.country,
                full_name: values.fullname,
                mobile_number: values.mobileNumber,
                default_address: transformedValues.defaultAddress,
                flat_house_building: values.address,
                area_street_sector: values.area,
                pincode: values.pinCode,
                landmark: values.landmark,
                town_city: values.city,
                state: values.state,
            };
            if (customer_address_id) {
                body.customer_address_id = customer_address_id
            }
            const apiEndpoint = `${apiURL}Customers/CreateCustomerAddress`;
            const response = await axios.post(apiEndpoint, body, { headers });
            if (response.data.success) {
                toast.success(response.data.message);
                resetForm();
                navigate("/MyAddress");

            }

        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleUpdate = async (values, { setSubmitting, resetForm, event }) => {
        event?.preventDefault();
        const transformedValues = {
            ...values,
            defaultAddress: values.defaultAddress ? 1 : 0,
        };

        try {
            const headers = apiHeaderJson;
            const body = {
                country_region: values.country,
                full_name: values.fullname,
                mobile_number: values.mobileNumber,
                default_address: transformedValues.defaultAddress,
                address: values.flat_house_building,
                area_street_sector: values.area,
                pincode: values.pinCode,
                landmark: values.landmark,
                town_city: values.city,
                state: values.state,
            };



            const apiEndpoint = `${apiURL}Customers/CreateCustomerAddress`;
            const response = await axios.post(apiEndpoint, body, { headers });


            if (response.data.success) {
                resetForm();
                navigate("/MyAddress")
            }

        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const GetCustomerAddressInfo = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}Customers/GetCustomerAddressInfo?customer_address_id=${customer_address_id}`, {
                headers
            });

            if (response.data.success) {
                const addressData = response.data.data[0];
                let updatedValues = {
                    country: addressData.country_region,
                    fullname: addressData.full_name,
                    mobileNumber: addressData.mobile_number,
                    address: addressData.flat_house_building,
                    area: addressData.area_street_sector,
                    pinCode: addressData.pincode,
                    landmark: addressData.landmark,
                    city: addressData.town_city,
                    state: addressData.state,
                    defaultAddress: addressData.default_address,
                };
                setInitialValues(updatedValues)
            }
        } catch (error) {
            console.error('Error fetching customer address info:', error);
        }
    };


    useEffect(() => {
        if (customer_address_id) {
            GetCustomerAddressInfo()
            setIsEdit(true)
        }
    }, [customer_address_id]);

   

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <FormUpdate isEdit={isEdit} onSubmit={handleCreate} initialValues={initialValues} validationSchema={AccountDetailsValidationSchema} />
    );
};

export default AddressDetails;
